import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, sub, img, testId }) {
  return (
    <section className="relative pt-[72px]" data-testid={testId}>
      <div className="relative min-h-[380px] flex items-end overflow-hidden">
        <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/55 to-navy/25" />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-navy/50 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-12 pt-24">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="eyebrow !text-ice"
          >
            {eyebrow}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.08, ease: EASE }}
            className="mt-3 font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl text-white leading-[1.02] max-w-2xl"
          >
            {title}
          </motion.h1>
          {sub && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.16, ease: EASE }}
              className="mt-4 max-w-xl text-base text-slate-200 leading-relaxed"
            >
              {sub}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
